import React from 'react';

import style from './about.module.scss';

import { Banner } from './banner';
import { Intro } from './intro';
import { Join } from './join';

export const About = () => {
    return (
        <div className={style.about}>
            <Banner></Banner>
            <Intro></Intro>
            <Join></Join>
        </div>
    );
};
